/**
 * Utility function to clear all preserved table states from sessionStorage
 * This is useful when navigating via sidebar to reset all filters/pagination
 */
export const clearAllTableStates = (): void => {
  try {
    const keysToRemove: string[] = [];

    // Find all keys that start with "table-state-"
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith("table-state-")) {
        keysToRemove.push(key);
      }
    }

    // Remove all found keys
    keysToRemove.forEach((key) => {
      try {
        sessionStorage.removeItem(key);
      } catch (error) {
        console.warn(`Failed to remove table state key ${key}:`, error);
      }
    });

    console.log(
      `Cleared ${keysToRemove.length} table state(s) from sessionStorage`,
    );
  } catch (error) {
    console.warn("Failed to clear table states from sessionStorage:", error);
  } finally {
    // sessionStorage.clear();
  }
};

/**
 * Clear table state for a specific module
 * @param key - The module key (e.g., "item", "enquiry")
 * @param tabIndex - Optional tab index for multi-tab modules
 */
export const clearTableState = (
  key: string,
  tabIndex?: number,
  tabString?: string,
): void => {
  try {
    let storageKey = `table-state-${key}`;

    if (tabString) {
      storageKey = `table-state-${key}-tab-${tabString}`;
    } else if (tabIndex !== undefined) {
      storageKey = `table-state-${key}-tab${tabIndex}`;
    }

    sessionStorage.removeItem(storageKey);
  } catch (error) {
    console.warn(`Failed to clear table state for ${key}:`, error);
  }
};
